/* ─── Container ─── */

.root {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  position: relative;
}

/* ─── Menu popup ─── */

.popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-2) 0;
  outline: none;
  transform-origin: bottom center;
  transition: opacity var(--motion-duration-medium1)
      var(--motion-easing-standard),
    transform var(--motion-duration-medium1) var(--motion-easing-standard);
  opacity: 1;
  transform: scale(1);
}

.popup[data-starting-style] {
  opacity: 0;
  transform: scale(0.9) translateY(0.5rem);
}

.popup[data-ending-style] {
  opacity: 0;
  transform: scale(0.9) translateY(0.5rem);
}

/* ─── Menu item row ─── */

.menuItem {
  display: inline-flex;
  align-items: center;
  gap: var(--space-3);
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.menuItem:focus-visible {
  border-radius: var(--shape-sm);
}

/* ─── Menu item label ─── */

.menuLabel {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
  background: var(--md-surface-container);
  padding: var(--space-1) var(--space-3);
  border-radius: var(--shape-xs);
  box-shadow: var(--elevation-1);
  white-space: nowrap;
  pointer-events: none;
}
